<script lang="ts">
	import Search from '$lib/components/Search.svelte';
	import PlacesSuggestion from './PlacesSuggestion.svelte';
	import type { ComponentType } from '$lib/types/props';
	import type { InputTextProps } from '$lib/elements/inputs/types';
	import { debounceAsync } from '../utils/global';
	import type { GeocodeResult } from '../types/Here';
	import ResultList from './ResultList.svelte';
	import { clickOutside } from '$lib/actions/clickOutside';
	import { t } from 'svelte-i18n';
	import { snackbar } from '$lib/stores/snackbar';
	import { error } from '@sveltejs/kit';

	export let onOptionClick: (el: GeocodeResult) => void;
	export let inputProps: InputTextProps;
	export let placeTypes: string = '';

	let suggestions = null;
	let isFetching = false;
	let inputRef;
	let isResultOpen = false;

	const onKeyUpHandler = debounceAsync(async () => {
		suggestions = null;
		inputProps.error = undefined;

		if (!inputProps.value) {
			return;
		}

		isFetching = true;
		const res = await fetch(
			encodeURI(`/places?search=${inputProps.value}${placeTypes ? '&types=' + placeTypes : ''}`)
		);
		if (res.ok) {
			const data = await res.json();
			if (data && data.length) {
				suggestions = data.map((s) => {
					let dynamicComponentObject: ComponentType = {
						component: PlacesSuggestion,
						props: {
							title: s.title,
							position: s.position,
							onClick: () => {
								suggestions = null;
								isResultOpen = false;
								inputProps.value = s.address?.label ?? s.title;
								if (onOptionClick) {
									onOptionClick(s);
								}
							}
						}
					};

					return dynamicComponentObject;
				});
				isResultOpen = true;
			} else {
				inputProps.error = $t('noResults');
			}
			isFetching = false;
		} else {
			snackbar.danger($t('places.error'));
			isFetching = false;
			error(res.status, { message: res.statusText, pathname: '/places' });
		}
	});
</script>

<div>
	<Search
		bind:props={inputProps}
		bind:this={inputRef}
		on:keyup={() => {
			onKeyUpHandler();
		}}
		on:click={() => {
			if (suggestions) isResultOpen = true;
		}}
	/>
	{#if isResultOpen || isFetching}
		<div
			class="relative w-full"
			use:clickOutside={{ action: () => (isResultOpen = false), excludedRefs: [inputRef] }}
		>
			<ResultList results={suggestions} {isFetching} />
		</div>
	{/if}
</div>
